import React, { useEffect, useState } from "react";
import { toast } from "react-toastify"; // Import toast from react-toastify
import "react-toastify/dist/ReactToastify.css"; // Import the CSS for toast notifications



const AddToCartModal = ({fetchCartDataMainPage,fetchBenefitsData, fetchCartData, isOpen, onClose,benefitsData,setBenefitsData,fetchCartDataMain }) => {
    const [checkedProducts, setCheckedProducts] = useState({});
    const login = JSON.parse(localStorage.getItem("login")) || false;
    // const [benefitsData, setBenefitsData] = useState([]);
    const [cart, setCart] = useState([]);

    const handleCheckboxChange = async (index, productmain) => {
        if (checkedProducts[index]?.state === "added") return;
        await handleAddToCart(index, productmain);
    };




   



    // const handleAddToCart = async (index, productmain) => {
    //     const login = JSON.parse(localStorage.getItem("login")) || {};
    //     const employeeId = login.emplyee_ID;
    //     const employeeName = login.full_name || "Guest";

    //     if (!employeeId) {
    //         toast.error("You must be logged in to add to cart.");
    //         return false;
    //     }

    //     try {
    //         const response = await fetch(`https://100billionrealestate.com/cart`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json"
    //             },
    //             body: JSON.stringify({
    //                 item_id: productmain.id,
    //                 product_title: productmain.title,
    //                 product_description: productmain.description,
    //                 product_icon: productmain.icon,
    //                 product_price: productmain.sale_price,
    //                 product_quantity: 1,
    //                 user_id: employeeId,
    //                 user_name: employeeName
    //             })
    //         });

    //         const result = await response.json();

    //         if (response.ok) {
    //             toast.success(`${productmain.title} added to cart!`);

    //             // ✅ Set checkbox checked after success
    //             setCheckedProducts((prev) => ({
    //                 ...prev,
    //                 [index]: {
    //                     state: "added",
    //                     productId: productmain.id
    //                 }
    //             }));

    //             fetchCartData(); // Refresh totals
    //             return true;
    //         } else {
    //             toast.error(result.message || "Already in cart");
    //             return false;
    //         }
    //     } catch (error) {
    //         console.error("Error adding to cart:", error);
    //         toast.error("Server error while adding to cart");
    //         return false;
    //     }
    // };

    const handleAddToCart = async (index, productmain) => {
        const login = JSON.parse(localStorage.getItem("login")) || {};
        const employeeId = login.emplyee_ID;
        const employeeName = login.full_name || "Guest";

        if (!employeeId) {
            toast.error("You must be logged in to add to cart.");
            return false;
        }

        try {
            const response = await fetch(`https://100billionrealestate.com/cart`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    item_id: productmain.id,
                    product_title: productmain.title,
                    product_description: productmain.description,
                    product_icon: productmain.icon,
                    product_ogprice: productmain.price,
                    product_price: productmain.sale_price,
                    product_quantity: 1,
                    user_id: employeeId,
                    user_name: employeeName
                })
            });

            const result = await response.json();

            if (response.ok) {
                toast.success(`${productmain.title} added to cart!`, {
                    autoClose: 500, 
                    hideProgressBar: true,
                    pauseOnHover: false,
                    draggable: false,
                });

                // ✅ Instantly remove the benefit from the UI
                setBenefitsData(prev => prev.filter((_, i) => i !== index));

                fetchCartData(); // Refresh totals
                fetchCartDataMainPage();
                return true;
            } else {
                toast.error(result.message || "Already in cart");
                return false;
            }
        } catch (error) {
            console.error("Error adding to cart:", error);
            toast.error("Server error while adding to cart");
            return false;
        }
    };



    // const fetchCartDataMain = async () => {
    //     try {
    //         const response = await fetch(`https://100billionrealestate.com/cart/getcartadded/${login.emplyee_ID}`);
    //         const data = await response.json();
    //         setCart(data);

    //         const cartItemIds = data.map(item => item.item_id);
    //         const filteredBenefits = benefitsData.filter(benefit => !cartItemIds.includes(String(benefit.id)));
    //         setBenefitsData(filteredBenefits);

    //     } catch (error) {
    //         console.error("Error fetching cart data:", error);
    //     }
    // };

    // addedItems.has(String(benefit.id))




    const handleRemoveFromCart = async (index, productmain) => {
        // const login = JSON.parse(localStorage.getItem("login")) || {};
        // const employeeId = login.emplyee_ID;
        // const productId = productmain.id;

        try {
            const response = await fetch(`https://100billionrealestate.com/cart/delete/${login.emplyee_ID}/${productmain.id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json"
                }

            });

            if (response.ok) {
                toast.success(`${productmain.title} removed from cart.`);
                setCheckedProducts((prev) => {
                    const updated = { ...prev };
                    delete updated[index];
                    return updated;
                });

                fetchCartData(); // Refresh totals
            } else {
                toast.error("Failed to remove from cart");
            }
        } catch (error) {
            console.error("Error removing item from cart:", error);
            toast.error("Server error while removing item");
        }
    };

    const handleContinue = () => {
        if (Object.keys(checkedProducts).length > 0) {
            toast.success("Products added to cart!");
        }
        onClose();
    };

    // useEffect(() => {
    //     const loadData = async () => {
    //         await fetchBenefitsData();
    //     };
    //     loadData();
    // }, [])aca;

    // useEffect(() => {
    //     if (isOpen) {
    //         fetchCartDataMain(); // Only run once when modal opens
    //     }
    // }, [isOpen]);
    


    if (!isOpen) return null;

    return (
        <div className="add-to-cart-modal-overlay">
            <div className="add-to-cart-modal-content">
                <button className="close-add-to-cart-modal-btn" onClick={onClose}>
                    <i className="fa-solid fa-xmark"></i> {/* X mark icon */}
                </button>
                <h2 className="add-to-cart-modal-title">Add to Cart</h2>
                {benefitsData.length === 0 ? (
                    <p style={{ textAlign: "center", margin: "20px 0", fontWeight: "500", color: "#777" }}>
                        🎉 All benefits are already added to your cart!
                    </p>
                ) : (benefitsData.map((product, index) => (
                    <div key={product.id} className="add-to-cart-product-info">
                        <div className="add-to-cart-modal-input-text">
                            <input
                                type="checkbox"
                                className="add-to-cart-checkbox"
                                checked={!!checkedProducts[index]}
                                onChange={() => handleCheckboxChange(index, product)}
                            />
                            <div className="add-to-cart-product-text">
                                <p className="add-to-cart-product-name">{product.title}</p>
                                <p className="add-to-cart-product-description">{product.description}</p>
                            </div>
                        </div>
                        <button
                            className={`add-cart-btn-modal ${checkedProducts[index]?.state === "added" ? "added" : ""}`}
                            onClick={() => handleAddToCart(index, product)}
                            disabled={checkedProducts[index]?.state === "added"} // Optional to prevent re-adding
                        >
                            {checkedProducts[index]?.state === "added" ? "Added" : "Add to Cart"}
                        </button>

                    </div>
                ))
                )}
                <button className="add-to-cart-continue-btn" onClick={handleContinue}>Continue</button>
            </div>
        </div>
    );
};

export default AddToCartModal;